import React from 'react'
import './header.css'
export default () => (
  <header className="header">
    <div className="green_banner_slim"></div>
    <div className="green_banner"></div>
  </header>
)
